// src/components/scenes/SoundActionEditor.js
import React, { useState } from 'react';
import './SoundActionEditor.css';

const SoundActionEditor = ({ action, onSave, onCancel }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [actionData, setActionData] = useState({
    type: 'sound',
    sound: '',
    volume: 100,
    ...action
  });
  
  // Handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setActionData(prev => ({
      ...prev,
      [name]: name === 'volume' ? parseInt(value, 10) : value
    }));
  };
  
  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!actionData.sound) {
      alert('Please enter a sound file name');
      return;
    }
    
    onSave(actionData);
  };
  
  return (
    <div className="sound-action-editor">
      <h2>{action ? 'Edit Sound Action' : 'Add Sound Action'}</h2>
      
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="sound">Sound File</label>
          <input
            type="text"
            id="sound"
            name="sound"
            value={actionData.sound}
            onChange={handleInputChange}
            placeholder="Enter sound filename (e.g. morning.mp3)"
            required
          />
          <small className="help-text">Sound files should be placed in the server/sounds directory</small>
        </div>
        
        <div className="form-group">
          <label htmlFor="volume">Volume ({actionData.volume}%)</label>
          <input
            type="range"
            id="volume"
            name="volume"
            min="0"
            max="100"
            value={actionData.volume}
            onChange={handleInputChange}
          />
        </div>
        
        <div className="editor-controls">
          <button 
            type="button"
            className="cancel-btn"
            onClick={onCancel}
            disabled={isLoading}
          >
            Cancel
          </button>
          
          <button 
            type="submit"
            className="save-btn"
            disabled={isLoading || !actionData.sound}
          >
            {isLoading ? (
              <>
                <div className="spinner-sm"></div>
                <span>Saving...</span>
              </>
            ) : (
              <span>Save Sound Action</span>
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default SoundActionEditor;